@if (activeItem(); as ai) {
    <a (mouseenter)="unSubscribe()" (mouseout)="subscribe(artBoards())" [routerLink]="['/gallery', category()._id]">
        <div class="overlay"></div>

        @for (b of artBoards(); track b; let i = $index) {
            <img
                #imgRef
                [ngSrc]="b.thumb.src"
                [ngClass]="{ opaque: i === activeArtBoardIndex() }"
                [width]="512"
                [height]="512"
                [placeholder]="thumb()"
                [attr.alt]="b.thumb.alt"
            />
        }

        <div class="desc">
            <h3>{{ category().name }}</h3>
        </div>
    </a>
}
